import { SearchablePicker } from "./searchable-picker"

export interface DonorOption {
  id: string
  code: string
  name: string
  email: string | null
  phone: string | null
  sponsorId: string | null
  sponsorName: string | null
  sponsorCode: string | null
}

function donorLabel(donor: DonorOption) {
  const sponsor = donor.sponsorCode ? ` · Sponsor ${donor.sponsorCode}` : ""
  return `${donor.code} · ${donor.name}${sponsor}`
}

export function DonorPicker({
  donors,
  value,
  onChange,
  onCreate,
  disabled = false,
}: {
  donors: DonorOption[]
  value: string
  onChange: (donorId: string) => void
  onCreate: () => void
  disabled?: boolean
}) {
  const selected = donors.find((donor) => donor.id === value)

  return (
    <div>
      <SearchablePicker
        items={donors}
        value={value}
        onChange={onChange}
        getLabel={donorLabel}
        getSearchText={(donor) => [donor.code, donor.name, donor.email, donor.sponsorName, donor.sponsorCode].filter(Boolean).join(" ")}
        renderOption={(donor) => (
          <>
            <span className="block font-medium">{donorLabel(donor)}</span>
            {(donor.email || donor.phone) && <span className="mt-0.5 block text-xs text-ink/50">{donor.email ?? donor.phone}</span>}
          </>
        )}
        label={<>Donor <span className="text-red-500">*</span></>}
        placeholder="Select donor"
        searchLabel="Search donors"
        searchPlaceholder="Search donors..."
        emptyMessage="No donors found."
        footer={{ label: "+ Create new donor", onClick: onCreate }}
        disabled={disabled}
      />
      {selected && <p className="mt-1 text-xs text-ink/50">{selected.email ?? selected.phone ?? "No contact details recorded"}</p>}
    </div>
  )
}
